"use client";

interface BalancePresetButtonsProps {
  balanceDisplay: string;
  applyPreset: (percent: number) => void;
  isNativeToken?: boolean;
}

const presetButtonClass =
  "rounded-md border border-ds-border-default px-2 py-0.5 text-xs font-medium text-ds-text-subtle transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 dark:text-ds-text-disabled dark:hover:border-blue-600 dark:hover:bg-blue-950/20 dark:hover:text-blue-400";

export default function BalancePresetButtons({
  balanceDisplay,
  applyPreset,
  isNativeToken,
}: BalancePresetButtonsProps) {
  return (
    <>
      <div className="flex-1" />
      <span className="text-xs text-blue-600 dark:text-blue-400">Balance: {balanceDisplay}</span>
      {[20, 50].map(pct => (
        <button key={pct} type="button" onClick={() => applyPreset(pct)} className={presetButtonClass}>
          {pct}%
        </button>
      ))}
      <button
        type="button"
        onClick={() => applyPreset(100)}
        className={presetButtonClass}
        title={isNativeToken ? "Leaves a small amount for gas fees" : undefined}
      >
        {isNativeToken ? "MAX (-gas)" : "MAX"}
      </button>
    </>
  );
}
